import config from '../../../config';
import { FLAGS_API_PATH } from '../../util/flags/constants';
import { BffFlagsResponse, FlagEnvironment } from '../../util/flags/types';
import { BaseRequestService } from '../BaseRequest.service';

export class FeatureFlagsService extends BaseRequestService {
  private static instance: FeatureFlagsService;

  protected getBaseUrl(): string {
    return `https://${config.gateway.url}`;
  }

  private constructor() {
    super();
  }

  static getInstance(): FeatureFlagsService {
    if (!this.instance) {
      this.instance = new FeatureFlagsService();
    }
    return this.instance;
  }

  public async getFlags(environment: FlagEnvironment) {
    return this.api.get<BffFlagsResponse>(`${FLAGS_API_PATH}/${environment}/flags`);
  }
}

export default FeatureFlagsService;
